<template>
        <div class="Welcome">
                <div class="page-wrapper">
                        <div class="col-md-12" style="margin-top:-50px;">
                                <img id="profile_picture" :src="user.meta_data.profile_picture"/>
                                <h4>{{user.name}}</h4>
                        </div>
                
                <form-wizard title="Welcome to Nutrivitas!" subtitle="Please set up your profile using the form wizard below." color="#34A1D9" @on-complete="updateProfile()">
                        <tab-content title="Profile Setup" :before-change="validateFistTab">
                                <form class="form-horizontal">
                                        <div class="form-group" :class="{'has-error':errors.first_name}">
                                                <label class="col-md-3 control-label " for="state-danger">Name & Surname</label>
                                                <div class="col-md-6">
                                                        <input type="text" v-model="profile.name" class="form-control" id="name" placeholder="Name & Surname">
                                                        <span class="help-block mt-10 mb-0 text-danger" v-if="errors.first_name"><small  class="text-danger">Name and surname required</small></span>
                                                </div>
                                        </div>
                                        <div class="form-group">
                                                <label class="col-sm-3 control-label">Gender</label>
                                                <div class="col-sm-9">
                                                        <div class="radio radio-primary">
                                                                <input type="radio" v-model="profile.gender" name="gender" id="gender-male" value="male" checked>
                                                                <label for="gender-male"> Male </label>
                                                        </div>
                                                        <div class="radio radio-info">
                                                                <input type="radio" v-model="profile.gender" name="gender" id="gender-female" value="female">
                                                                <label for="gender-female"> Female </label>
                                                        </div>
                                                </div>
                                        </div>
                                        <div id="female-question" v-if="profile.gender == 'female'">
                                                <div class="form-group col-sm-6">
                                                        <label class="col-sm-6 control-label">
                                                                Are you Pregnant?
                                                        </label>
                                                        <div class="col-sm-6">
                                                                <div class="radio">
                                                                        <input type="radio" name="pregnant" id="pregnant-no" value="0" v-bind="profile.is_pregnant">
                                                                        <label for="pregnant-no"> No </label>
                                                                </div>
                                                                <div class="radio">
                                                                        <input type="radio" name="pregnant" id="pregnant-yes" value="1" v-bind="profile.is_pregnant">
                                                                        <label for="pregnant-yes"> Yes </label>
                                                                </div>
                                                        </div>
                                                </div>
                                                <div class="form-group col-sm-6">
                                                        <label class="col-sm-6 control-label">
                                                                Are you lactating?
                                                        </label>

                                                        <div class="col-sm-6">
                                                                <div class="radio">
                                                                        <input type="radio" name="lactating" id="lactating-no" value="0"  v-bind="profile.is_lactating">
                                                                        <label for="lactating-no"> No </label>
                                                                </div>
                                                                <div class="radio">
                                                                        <input type="radio" name="lactating" id="lactating-yes" value="1" v-bind="profile.is_lactating">
                                                                        <label for="lactating-yes"> Yes </label>
                                                                </div>
                                                        </div>
                                                </div>
                                                <div class="col-sm-9 col-sm-offset-3">
                                                        <span class="help">These options will be used to display the daily recommanded Vitamins & Minerals only.</span>
                                                        <hr/>
                                                </div>                                                
                                        </div>
                                        <div class="form-group mg-t-30" :class="{'has-error':errors.date_of_birth}">
                                                <label class="col-md-3 control-label " for="state-danger">Date of Birth</label>
                                                <div class="col-md-6">
                                                        <!-- <datepicker format="dd/MM/yyyy" v-model="profile.date_of_birth" inputClass="form-control"></datepicker> -->
                                                        <datetime v-model="profile.date_of_birth" input-id="startDate" format="dd/MM/yyyy">
                                                                <template slot="button-cancel">
                                                                        <fa :icon="['far', 'times']"></fa>
                                                                        Cancel
                                                                </template>
                                                                <template slot="button-confirm">
                                                                        <fa :icon="['fas', 'check-circle']"></fa>
                                                                        Confirm
                                                                </template>
                                                        </datetime>
                                                        <span class="help-block mt-10 mb-0 text-danger" v-if="errors.date_of_birth"><small  class="text-danger">Date of birth required</small></span>
                                                </div>
                                        </div>

                                        <div class="form-group">
                                                <label class="col-sm-3 control-label">
                                                        Preferred units
                                                </label>

                                                <div class="col-sm-9">
                                                        <div class="radio">
                                                                <input type="radio" name="preferred_units" v-model="profile.preferred_units" id="units-imperial" value="imperial">
                                                                <label for="units-imperial"> Imperial </label>
                                                        </div>
                                                        <div class="radio">
                                                                <input type="radio" name="preferred_units" v-model="profile.preferred_units" id="units-metric" value="metric">
                                                                <label for="units-metric"> Metric </label>
                                                        </div>
                                                </div>
                                        </div>

                                        <div class="form-group mg-t-30 col-sm-6" :class="{'has-error':errors.height}">
                                                <label class="col-md-6 control-label" for="state-danger">Height</label>
                                                <div class="col-md-6">
                                                        <div class="input-group col-sm-12">
                                                                <input type="number" class="form-control" id="name" placeholder="Height" v-model="profile.height"> 
                                                                <span class="input-group-addon">{{profile.preferred_units == "metric" ? "cm" : "in"}}</span>
                                                        </div>
                                                        <span class="help-block mt-10 mb-0 text-danger" v-if="errors.height"><small  class="text-danger">Height required</small></span>
                                                </div>
                                        </div>

                                        <div class="form-group mg-t-30 col-sm-6" :class="{'has-error':errors.weight}">
                                                <label class="col-md-6 control-label" for="state-danger">Weight</label>
                                                <div class="col-md-6">
                                                        <div class="input-group col-sm-12">
                                                                <input type="number" class="form-control" id="weight" placeholder="Weight" v-model="profile.initial_weight"> 
                                                                <span class="input-group-addon">{{profile.preferred_units == "metric" ? "kg" : "lbs"}}</span>
                                                        </div>
                                                        <span class="help-block mt-10 mb-0 text-danger" v-if="errors.weight"><small  class="text-danger">Weight required</small></span>
                                                </div>
                                        </div>
                                </form>
                        </tab-content>
                        <tab-content title="Activity Level" :before-change="validateSecondTab">
                                <h4>How often do you exercise?</h4>
                                
                                <div class="col-sm-12 exercise-control">
                                        <select name="" id="" class="form-control" v-model="profile.exercise_level">
                                                <option value="1.2">Light to no exercise</option>
                                                <option value="1.375">Light exercise 1-3 days per week</option>								
                                                <option value="1.55">Moderate exercise 3-5 days per week</option>								
                                                <option value="1.725">Hard exercise 6-7 days per week</option>
                                                <option value="1.9">Very intense exercise</option>
                                        </select>
                                </div>
                                <div class="col-sm-12">
                                        <div class="alert alert-danger alert-dismissable" v-if="errors.exercise_level">
                                                Exercise Level Required
                                        </div>
                                </div>


                                <h4>What’s your day like when you are not exercising?</h4>

                                <div class="col-sm-4">
                                        <div class="activity_level sitting" 
                                        :class="[
                                                (profile.activity_level != '1' && profile.activity_level != null ? 'activity_discarded' : ''),
                                                (profile.activity_level == '1' ? 'activitity_level_selected' : '')
                                        ]" @click="profile.activity_level = 1">
                                                <h5>Sitting</h5>
                                                <p>I don’t move around as much as I’d like . I’m at my desk most of my day with maybe some walking around.</p>                                        
                                        </div>
                                </div>
                                <div class="col-sm-4">
                                        <div class="activity_level onmyfeet" 
                                        :class="[
                                                (profile.activity_level != '2' && profile.activity_level != null ? 'activity_discarded' : ''),
                                                (profile.activity_level == '2' ? 'activitity_level_selected' : '')
                                        ]" @click="profile.activity_level = 2">
                                                <h5>On my feet</h5>
                                                <p>I spend much of the day on my feet working, doing things like heavy cleaning or waiting tables.</p>
                                        </div>
                                </div>
                                <div class="col-sm-4">
                                        <div class="activity_level hustling" 
                                        :class="[
                                                (profile.activity_level != '3' && profile.activity_level != null ? 'activity_discarded' : ''),
                                                (profile.activity_level == '3' ? 'activitity_level_selected' : '')
                                        ]" @click="profile.activity_level = 3">
                                                <h5>Hustling</h5>
                                                <p>I have a physically active job and am active most of the time.</p>
                                        </div>
                                </div>
                                <div class="col-sm-12">
                                        <div class="alert alert-danger alert-dismissable" v-if="errors.activity_level">
                                                Activity Level Required
                                        </div>
                                </div>
                                
                        </tab-content>
                        <tab-content title="My Diet Goals" :before-change="validateThirdTab">
                        <h4>My Diet Goals</h4>
                        <div class="diet_goals_container">
                                <div class="form-group">
                                        <div class="col-sm-3 col-sm-offset-2">
                                                <div class="radio">
                                                        <input type="radio" v-model="profile.diet_goal" name="diet_goal" id="dietgoal-weightloss" value="weightloss" checked="checked">
                                                        <label for="dietgoal-weightloss"> Weight Loss</label>
                                                </div>
                                        </div>
                                        <div class="col-sm-3">
                                                <div class="radio">
                                                        <input type="radio" v-model="profile.diet_goal" name="diet_goal" id="dietgoal-eatbalanced" value="eatbalanced">
                                                        <label for="dietgoal-eatbalanced"> Eat Balanced</label>
                                                </div>
                                        </div>
                                        <div class="col-sm-3">
                                                <div class="radio">
                                                        <input type="radio" v-model="profile.diet_goal" name="diet_goal" id="dietgoal-buildmuscle" value="buildmuscle">
                                                        <label for="dietgoal-buildmuscle"> Build Muscle</label>
                                                </div>
                                        </div>
                                </div>
                                <div class="col-sm-12">
                                        <div class="alert alert-danger alert-dismissable" v-if="errors.diet_goal">
                                                Diet Goal Required
                                        </div>
                                </div>
                        </div>

                        </tab-content>
                        <tab-content title="My Body" :before-change="validateFourthTab">
                        <h4>Where is most of the fat stored in your body?</h4>
                        <div class="body_fat_stored_images" style="margin: 0 auto; width: 80%">
                                <img src="dist/img/bfd1.png" alt="" :class="profile.body_fat_distribution == 1 ? 'bfd-chosen' : ''" @click="profile.body_fat_distribution = 1">
                                <img src="dist/img/bfd2.png" alt="" :class="profile.body_fat_distribution == 2 ? 'bfd-chosen' : ''" @click="profile.body_fat_distribution = 2">
                                <img src="dist/img/bfd3.png" alt="" :class="profile.body_fat_distribution == 3 ? 'bfd-chosen' : ''" @click="profile.body_fat_distribution = 3">
                                <img src="dist/img/bfd4.png" alt="" :class="profile.body_fat_distribution == 4 ? 'bfd-chosen' : ''" @click="profile.body_fat_distribution = 4">
                                <img src="dist/img/bfd5.png" alt="" :class="profile.body_fat_distribution == 5 ? 'bfd-chosen' : ''" @click="profile.body_fat_distribution = 5">
                                <img src="dist/img/bfd6.png" alt="" :class="profile.body_fat_distribution == 6 ? 'bfd-chosen' : ''" @click="profile.body_fat_distribution = 6">
                        </div>
                        <div class="col-sm-2"></div>
                        
                        <div class="diet_goals_container col-sm-12">
                                <h5>Describe your body type</h5>
                                <div class="form-group">
                                        <div class="col-sm-3 col-sm-offset-2">
                                                <div class="radio">
                                                        <input type="radio" v-model="profile.body_type" name="diet_goal" id="bodytype-slim" value="slim" checked>
                                                        <label for="bodytype-slim"> Slim </label>
                                                </div>
                                        </div>
                                        <div class="col-sm-3">
                                                <div class="radio">
                                                        <input type="radio" v-model="profile.body_type" name="diet_goal" id="bodytype-normal" value="normal">
                                                        <label for="bodytype-normal"> Normal </label>
                                                </div>
                                        </div>
                                        <div class="col-sm-3">
                                                <div class="radio">
                                                        <input type="radio" v-model="profile.body_type" name="diet_goal" id="bodytype-stocky" value="stocky">
                                                        <label for="bodytype-stocky"> Stocky </label>
                                                </div>
                                        </div>
                                </div>
                        </div>
                        <div class="col-sm-12">
                                <div class="alert alert-danger alert-dismissable" v-if="errors.body_type">
                                        Body Type Required
                                </div>
                        </div>
                        <div class="col-sm-12">
                                <div class="alert alert-danger alert-dismissable" v-if="errors.body_fat_distribution">
                                        Please specify where most of the fat is stored in your body
                                </div>
                        </div>
                        </tab-content>
                        <tab-content title="T&Cs" :before-change="validateFifthTab">
                                <div class="panel panel-default card-view">
                                        <div class="panel-heading">
                                                <div class="pull-left">
                                                        <h6 class="panel-title txt-light">Terms and Conditions</h6>
                                                </div>
                                                <div class="clearfix"></div>
                                        </div>
                                        <div  class="panel-wrapper collapse in">
                                                <div  class="panel-body" style="max-height:200px; overflow-y:scroll;">
                                                        <p v-html="terms">

                                                        </p>
                                                </div>
                                        </div>
                                </div>
                                <div class="form-group">
                                        <input type="checkbox" name="" id="check_t_and_c" v-model="profile.agreed_to_terms_and_conditions">&nbsp;&nbsp;&nbsp;<label for="check_t_and_c">I Accept the above terms and Conditions</label>
                                </div>
                                <div class="form-group">
                                        <input type="checkbox" name="" id="check_newsletter" v-model="profile.subscribed_to_newsletter">&nbsp;&nbsp;&nbsp;<label for="check_newsletter">I would like to receive newsletters from Nutrivitas</label>
                                </div>
                                
                                <div class="col-sm-12">
                                        <div class="alert alert-danger alert-dismissable" v-if="errors.terms_and_conditions">
                                                Please agree to the terms and conditions
                                        </div>
                                </div>
                        </tab-content>
                </form-wizard>
                </div>


                <!--measurementsTrackingModal-->
                <!-- Weight Tracking Modal -->
                <div id="paymentModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                        <div class="modal-dialog">
                                <div class="modal-content">
                                        <div class="modal-body">
                                                <div class="modal-header-icon">
                                                        <img src="dist/img/icons/vip.png" alt="measurements">
                                                        <h4>Go VIP</h4>
                                                        <br/>
                                                        <br/>
                                                        <form v-if="showpaymentform" @submit.prevent="handleSubmitPayment" action="http://localhost:8080" class="paymentWidgets" data-brands="VISA MASTER AMEX"></form>
                                                </div>
                                        </div>
                                        <div class="modal-footer">
                                                <button type="button" class="btn btn-info" data-dismiss="modal" ref="measurementTrackerClose">Close</button>
                                                <!-- <button type="button" class="btn btn-success" @click="addWeight">Track</button> -->
                                        </div>
                                </div>
                                <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->

                        <!-- /.modal -->
                </div>
        </div>
</template>

<script>
import API from "../../services/api.js";
import AppHeader from '../../components/common/AppHeader.vue'
import AppFooter from '../../components/common/AppFooter.vue'
import Datepicker from 'vuejs-datepicker';
import {
        FormWizard,
        TabContent
} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

const api = new API();

var store = this.$store;
export default {
        components: {
                FormWizard,
                TabContent,
                Datepicker,
                Datetime
        },
        data() {
                return {
                //#region Terms
                        terms: `
                        <h3>NutriVitas-Terms and Conditions of Use</h3>
                        <br>
                        By accessing or using NutriVitas website, www.nutrivitas.com (the “Site” or the “Website”) and NutiVitas Mobile Apps (“Mobile Apps”), you agree to be bound by the following terms and conditions governing use of the Site (the “Terms of Use”). If you do not agree to these Terms of Use, you should not use or access the Site.
                        <br><br>
                        <h4>NutriVitas Shop</h4>
                        <br>
                        <strong>RETURNS POLICY</strong>
                        <br><br>
                        NutriVitas.com accepts the return of goods purchased on the NutriVitas website only if they are unopened and in their original condition. Should you return the goods within 14 days of receipt we will issue a full refund for the price you paid for the item , you are entitled to expect your money to be refunded within 1-2 working days of the item being accepted back into our warehouse. Please note that you will be responsible for the costs of returning the goods to us unless we delivered the item to you in error or the item is faulty.
                        <br><br>
                        For your protection we recommend you use a fully tracked and insured service as NutriVitas is not liable for any loss or damages during transit of the returned item/s.
                        <br><br>
                        <strong>Refunds (if applicable)</strong>
                        <br><br>
                        Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund.
                        If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within a certain amount of days.
                        <br><br>
                        <strong>Customer Requested Cancellations</strong>
                        <br><br>
                        After you have clicked “Complete order”, we are unable to cancel or change your order. Our system has been created to process and ship orders instantly. Once you have received your order, simply follow our Return Instructions and return any items you do not want.
                        <br><br>
                        <strong>Return Instructions</strong>
                        <br><br>
                        To return your product, you should mail your product to:
                        <br>
                        NUTRIVITAS
                        <br><br>
                        51 Adriatic Street
                        <br><br>
                        4 Olympic , San Gwann
                        <br><br>
                        MALTA
                        <br><br>
                        You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund.
                        <br><br>
                        Depending on where you live, the time it may take for your exchanged product to reach you may vary.
                        <br><br>
                        <strong>Use of Website</strong>
                        <br><br>
                        The purpose of the Website and Mobile Apps is to provide online diet and health services. The content of the Website is for general information purposes only and is for your personal and non-commercial use. You may only use the Website in accordance with these Terms of Use, and may not use the Website to engage in any unlawful activity or fraudulent purpose or to infringe on the rights of NutriVitas, its affiliates or others.
                        <br><br>
                        <strong>Not Medical Advice</strong>
                        <br><br>                        
                        All content available on the Website and in Mobile Apps, including but not limited to calorie counts, nutritional facts, charts and projections, is believed to be accurate and in accordance with guidelines published by the “FDA”, including guidelines relating to the Recommended Daily Allowances (“USRDA”), the Academy of Nutrition and Dietetics and other applicable authorities. However, the Site and its content does not consist of nor provide medical advice and is not a substitute for medical advice. Results, such as those based on calorie counts or projected weight loss, may vary. Always seek the advice of a licensed medical provider before undertaking any weight loss plan. Reliance on any information provided by or found on the Site is purely at your own risk. Information posted on the Website and in Mobile Apps may not be accurate or current and NutriVitas does not have an obligation under these Terms of Use to update the Site based on changes to the USRDA or other applicable guidelines or laws.
                        <br><br>
                        <strong>Not Medical Device</strong>
                        <br><br>
                        NutriVitas  is an educational tool, it is not a medical device, it is not a substitute for a medical device or medical care, and it does not provide diagnosis, cure, mitigation, treatment, or prevention of any disease.
                        Information provided on NutriVitas web site and in NutriVitas applications is for general use only and is not intended to provide personal medical advice or substitute for the advice of your physician. If you have questions or concerns about individual health matters or the management of your diabetes, please consult your doctor.
                        <br><br>
                        <strong>Proprietary Information</strong>
                        <br><br>
                        As between you and NutriVitas, all content on the Website and in Mobile Apps, including its appearance and look and feel, is owned by NutriVitas unless otherwise expressly indicated on the Site. You may not modify, copy, distribute, transmit, display, perform or create derivative works from the content, information or material on the Website and in Mobile Apps.
                        <br><br>
                        Any NutriVitas trademarks, trade dress, service marks or trade names that appear on the Site or are referenced on the Site are the property of NutriVitas and no license or other right to use such marks, names or dress shall be deemed granted without the express written permission of NutriVitas.
                        <br><br>
                        <strong>User Supplied Content</strong>
                        <br><br>
                        You understand and acknowledge that you are solely responsible for all information, data, text or other materials or content that you provide to NutriVitas via the Website and in Mobile Apps. NutriVitas is not responsible or liable for this information. When you post or transmit information through the Site, you grant NutriVitas an irrevocable, non-exclusive, royalty-free, sublicensable, world wide license to use such information for any purpose.
                        <br><br>
                        You agree that you will not post offensive, abusive, harassing, unlawful or otherwise objectionable material on the Site. NutriVitas reserves the right but not the obligation to remove, edit or relocate any user supplied content at its sole discretion.
                        <br><br>
                        All user supplied content or communications transmitted via the Website and in Mobile Apps are not confidential. You should not discuss, provide, solicit or request Personally Identifiable Information or Protected Health Information on the Website and in Mobile Apps. If you disclose, discuss or provide any information, including Personally Identifiable Information and Protected Health Information, on the Website and in Mobile Apps, including on any forums, chat rooms, message boards, blogs or communities, you do so at your own risk and you are solely responsible for the consequences of disclosing, discussing or providing such information.
                        <br><br>
                        <strong>Other Third Party Contributors</strong>
                        The views expressed by any contributor to this Website and Mobile Apps, whether an independent contractor, are those of the contributor alone. Such views do not reflect the beliefs, feelings, policies or position of NutriVitas.
                        <br><br>
                        Any opinions, advice, statements, services, offers or other information or content expressed or made available on the Website and in Mobile Apps by third parties, including other users, are those of the respective third parties and not of NutriVitas. NutriVitas neither endorses nor is responsible for the accuracy or reliability of any opinions, advice, statements, services, offers or other information or content expressed or made available on the Site by such parties. If you disclose, discuss or provide any information to such third parties on the Website and in Mobile Apps, you do so at your own risk and NutriVitas is not responsible nor liable for the consequences of such disclosures or discussions.
                        <br><br>
                        <strong>Permitted users</strong>
                        <br><br>
                        Due to the nature of our service, we restrict access to our Website and Mobile Apps to those who may safely use it. The following users are prohibited, either completely or partially, from using the Site.
                        <br><br>
                        - Individuals with serious medical conditions.If you have a serious medical condition, including but not limited to pregnancy, diabetes, high blood pressure, cancer or heart disorders, you may not use this Site without the prior approval of your physician or other licensed healthcare provider.<br>
                        - Individuals who suffer from eating disorders.If you suffer from anorexia nervosa, bulimia, or other related eating disorders, you are not permitted to use this Site.<br>
                        - We are committed to protecting the privacy of children and haveno intention of collecting personal information from individuals under the age of 18. If you are under the age of 18, do not submit personal information to this Site without the consent of your Parent or Legal Guardian. No one under the age of 18 is permitted to use this Site without the direct supervision of his/her Parent, Legal Guardian, and/or other legally authorized person. If you are a Parent, Legal Guardian or other legally authorized person, you hereby agree to the INDEMNIFICATION provision below in all of its terms as it relates to the use of this Site by your minor ward(s) whom you have allowed to use this Site. Children under the age of 13 are not permitted to use this Site.
                        <br><br>
                        <strong>Automatic Renewal</strong>
                        <br><br>
                        By signing up for NutriVitas subscription, you agree that your subscription will be automatically renewed. The period of auto-renewal will be the same as your initial subscription period unless otherwise disclosed to you at the time of subscription purchase. The renewal rate will be no more than the rate for the immediately prior subscription period. If you want to cancel subscription, follow instructions provided on Account page in the member section of the Site. We will not prorate fees for a cancelled subscription. From time to time, we may offer a free trial subscription for a service. If you register for a free trial subscription, we will begin to bill your account when the free trial subscription expires, unless you cancel your subscription before that time.
                        <br><br>
                        <strong>Registration and Password</strong>
                        <br><br>
                        You are responsible for maintaining the confidentiality of your sign-in information and password. You are responsible for all uses of your account, whether or not authorized by you. You agree to immediately notify NutriVitas of any unauthorized uses of your account.
                        <br><br>
                        <strong>Account Cancellation</strong>
                        <br><br>
                        Users of the Website and Mobile Apps may cancel their accounts at any time. There is no minimum commitment to open or maintain an account. The cancellation form can be found on the Account page in the member section of the Site.
                        <br><br>
                        The Site’s service is billed in advance and its fees are nonrefundable. There are no refunds or credits for partial months of service or for unused months of membership. In order to treat all users equally, no exceptions will be made.
                        <br><br>
                        <strong>No Warranty</strong>
                        <br><br>
                        THE CONTENT AND OTHER MATERIALS CONTAINED HEREIN ARE PROVIDED “AS IS” AND TO THE MAXIMUM EXTENT PERMITTED BY LAW, NutriVitas, ITS AFFILIATES AND THEIR RESPECTIVE OFFICERS, DIRECTORS, AGENTS, SUBCONTRACTORS, SUPPLIERS AND REPRESENTATIVES HEREBY DISCLAIM (1) ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF NON-INFRINGEMENT, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, THAT THE WEBSITE’S AND MOBILE APPS’ CONTENT, FUNCTIONS, OPERATION OR AVAILABILITY WILL BE UNINTERRUPTED OR ERROR FREE, THAT DEFECTS WILL BE CORRECTED OR THAT THE WEBSITE AND MOBILE APPS OR THE SYSTEMS THAT MAKE THEM AVAILABLE WILL BE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS AND (2) ANY LIABILITY FOR ERRORS OR OMISSIONS IN THE CONTENT CONTAINED ON THE WEBSITE AND IN MOBILE APPS, AND FOR ANY DOWNTIME EXPERIENCED ON THE WEBSITE.
                        <br><br>
                        <strong>Limitation of Liability</strong>
                        <br><br>
                        NutriVitas, and its officers, directors, employees and agents, shall not be responsible or liable for or in connection with browsing or other use of the Website and Mobile Apps or Content (as defined below) or downloading any materials or Content from the Website and Mobile Apps, including but not limited to any liability for errors, inaccuracies, omissions or misleading statements. Users of the Website and Mobile Apps expressly understand and agree that such use is at their own risk and that NutriVitas shall not be liable to any user of the Website abd Mobile Apps, or to any third party, for any loss, expense or damage, including but not limited to consequential, incidental, special, direct, indirect or punitive damages of any kind, including lost profit or revenue, however such damages arise, that results directly or indirectly from the use of or reliance upon the Website and Mobile Apps, Content or other information obtained, downloaded, linked or otherwise accessed through the Website, even if NutriVitas has been advised of the possibility of such damages.
                        <br><br>
                        Any transactions, communications or other dealings you have with third parties found on or through the Website and Mobile Apps are solely between you and the third party. NutriVitas makes no representations or warranties with respect to such third parties offering services on the Website and in Mobile Apps. NutriVitas shall not be responsible nor liable for or in connection with any such third party transactions, communications or other dealings.
                        <br><br>
                        <strong>Indemnification</strong>
                        You hereby agree to indemnify, defend, release and hold harmless NutriVitas, its officers, directors, employees and agents from and against any and all third party claims, liability, damages and/or costs (including, but not limited to, attorneys’ fees) incurred as a result of or arising from (i) your use of the Site or access by others to the Site under your authority or control or (ii) content or other information you submit, disclose, discuss or provide on the Site.
                        <br><br>
                        <strong>Disclaimers</strong>
                        <br><br>
                        The Website and Mobile Apps allow you to access and view content, including but not limited to calorie counts, nutritional facts, charts, projections and other related information provided by NutriVitas, its licensors, users and other third parties (collectively, the “Content”). The Content contained on the Website and in Mobile Apps is not guaranteed by NutriVitas to be accurate, complete, current or reliable and is subject to errors, omissions or withdrawal without notice.
                        <br><br>
                        No agency or other governmental authority has judged the merits or value, if any, of the information provided on the Website and in Mobile Apps and it may be advisable for you to consult a medical professional prior to using the materials contained on this Site.
                        <br><br>
                        Additional disclaimers may appear within the body of the Website and in Mobile Apps and are incorporated herein by reference.
                        <br><br>
                        <strong>Termination of Access</strong>
                        <br><br>
                        You acknowledge that NutriVitas may terminate your access to this Site or membership to this Site at any time, for any reason, with or without cause.
                        <br><br>
                        <strong>Changes to Website and Mobile Apps</strong>
                        <br><br>
                        NutriVitas reserves the right to modify these Terms of Use and to change, suspend or discontinue all or any portion of the Website and Mobile Apps or their Content at any time, in its discretion, without notice.
                        <br><br>
                        <strong>Waiver</strong>
                        <br><br>
                        Any waiver of any provision of the Terms of Use will be effective only if in writing and signed by NutriVitas.
                        <br><br>
                        <strong>Questions, Comments, Complaints or Service Issues</strong>
                        <br><br>
                        If you have any questions, comments, complaints or service issues pertaining to this Website and Mobile Apps, please contact us at info@nutrivitas.com.
                        <br><br>
                        Copyright © I NutriVitas  201. All Rights reserved.
                        <br><br>
                        COMPANY INFORMATION<br>
                        NutriVitas<br>
                        51 Adriatic Street, 4 Olympic
                        <br><br>
                        San Gwann , SGN 1812
                        <br><br>
                        MALTA`,
                //#endregion
                        showpaymentform:false,
                        user: this.$store.getters.user,
                        slickOptions: {
                                slidesToShow: 3,
                                dots: true
                                // Any other options that can be got from plugin documentation
                        },
                        profile: {
                                name: this.$store.getters.user.name,
                                gender: "male",
                                preferred_units: "metric",
                                is_pregnant: false,
                                is_lactating: false,
                                height: null,
                                initial_weight: null,
                                date_of_birth: null,
                                activity_level: null,
                                exercise_level: null,
                                body_fat_distribution: null,
                                body_type: null,
                                membership_type: null,
                                diet_goal: null,
                                agreed_to_terms_and_conditions:false,
                                subscribed_to_newsletter:true
                        },
                        errors: {
                                first_name: false,
                                date_of_birth: false,
                                height: false,
                                weight: false,
                                activity_level: false,
                                exercise_level: false,
                                diet_goal: false,
                                body_fat_distribution: false,
                                body_type: false,
                                terms_and_conditions: false
                        }
                }
        },
        methods: {
                handleSubmitPayment(){
                        console.info("HERE we are. Submitting the payment");
                },
                validateFistTab() {
                        let errors = false;

                        if (this.profile.name == null || this.profile.name == "") {
                                this.errors.first_name = true;
                                errors = true;
                        }

                        if (this.profile.date_of_birth == null || this.profile.date_of_birth == "") {
                                this.errors.date_of_birth = true;
                                errors = true;
                        } else {
                                this.errors.date_of_birth = false;
                        }

                        if (this.profile.height == null || this.profile.height == "") {
                                this.errors.height = true;
                                errors = true;
                        } else {
                                this.errors.height = false;
                        }

                        if (this.profile.initial_weight == null || this.profile.initial_weight == "") {
                                this.errors.weight = true;
                                errors = true;
                        } else {
                                this.errors.weight = false;
                        }

                        return !errors;
                },
                validateSecondTab() {
                        let errors = false;

                        if (this.profile.activity_level == null || this.profile.activity_level == "") {
                                this.errors.activity_level = true;
                                errors = true;
                        }

                        if (this.profile.exercise_level == null || this.profile.exercise_level == "") {
                                this.errors.exercise_level = true;
                                errors = true;
                        } else {
                                this.errors.exercise_level = false;
                        }

                        return !errors;
                },
                validateThirdTab() {
                        let errors = false;

                        if (this.profile.diet_goal == null || this.profile.diet_goal == "") {
                                this.errors.diet_goal = true;
                                errors = true;
                        }
                        return !errors;
                },
                validateFourthTab() {
                        let errors = false;

                        if (this.profile.body_fat_distribution == null || this.profile.body_fat_distribution == "") {
                                this.errors.body_fat_distribution = true;
                                errors = true;
                        }

                        if (this.profile.body_type == null || this.profile.body_type == "") {
                                this.errors.body_type = true;
                                errors = true;
                        }
                        return !errors;
                },
                validateFifthTab(){
                        let errors = false;

                        if (this.profile.agreed_to_terms_and_conditions == false) {
                                this.errors.terms_and_conditions = true;
                                errors = true;
                        }else{
                                this.errors.terms_and_conditions = false;
                        }

                        return !errors;
                },
                updateProfile() {
                        api.updateProfile(this.profile).then(async response => {
                                if (response.data.success) {
                                        this.$store.commit('updateUser', response.data.data);
                                        if (this.$store.getters.user.meta_data.first_time_user) {
                                                this.navigate("/welcome");
                                        } else {
                                                this.navigate("/dashboard");
                                        }
                                }
                        });
                },
                next() {
                        this.$refs.slick.next();
                },

                prev() {
                        this.$refs.slick.prev();
                },

                reInit() {
                        // Helpful if you have to deal with v-for to update dynamic lists
                        this.$nextTick(() => {
                                this.$refs.slick.reSlick();
                        });
                },

                // Events listeners
                handleAfterChange(event, slick, currentSlide) {
                        console.log('handleAfterChange', event, slick, currentSlide);
                },
                handleBeforeChange(event, slick, currentSlide, nextSlide) {
                        console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
                },
                handleBreakpoint(event, slick, breakpoint) {
                        console.log('handleBreakpoint', event, slick, breakpoint);
                },
                handleDestroy(event, slick) {
                        console.log('handleDestroy', event, slick);
                },
                handleEdge(event, slick, direction) {
                        console.log('handleEdge', event, slick, direction);
                },
                handleInit(event, slick) {
                        console.log('handleInit', event, slick);
                },
                handleReInit(event, slick) {
                        console.log('handleReInit', event, slick);
                },
                handleSetPosition(event, slick) {
                        console.log('handleSetPosition', event, slick);
                },
                handleSwipe(event, slick, direction) {
                        console.log('handleSwipe', event, slick, direction);
                },
                handleLazyLoaded(event, slick, image, imageSource) {
                        console.log('handleLazyLoaded', event, slick, image, imageSource);
                },
                handleLazeLoadError(event, slick, image, imageSource) {
                        console.log('handleLazeLoadError', event, slick, image, imageSource);
                },
                createPaymentLink() {
                        api.prepareCheckout().then(async response => {
                                let paymentScript = document.createElement('script')
                                paymentScript.setAttribute('src', 'https://test.swishme.eu/v1/paymentWidgets.js?checkoutId=' + response.data.data)
                                document.head.appendChild(paymentScript)
                                this.showpaymentform = true;
                        });
                }
        },
        created: function () {
                
        },
        watch: {}
}
</script>


<style scoped>
        .page-wrapper{
                margin:0;
                background-image: url('https://s3.us-east-2.amazonaws.com/loopdigital-nutrivitas/webapp/Login-BG.jpg') !important;
                background-size: cover !important;
        }
        .Welcome{
                text-align: center;
        }
        #profile_picture{
                border-radius: 50%;
                max-width: 150px;
        }

        .vue-form-wizard{
                max-width:1000px;
                margin:0 auto;
                border:1px solid #ccc;
                border-radius: 10px;
                padding:20px;
                margin-top:30px;
                text-align: left;
                background: #fff;
        }

        .help{
                display: block;
                font-size: 11px;
                color:#777;
        }

        .form-control input{
                border: none!important;
                margin-top: 5px;
        }

        .exercise-control{
                padding-top: 15px;
                padding-bottom: 15px;
        }

        .activity_level{
                margin-top:50px;
                margin-bottom:50px;
                padding:20px;
                border:1px solid #eee;
                height:200px;
                cursor: pointer;
                border-radius: 20px;
        }

        .activity_level h5{
                margin-top:10px;
                margin-bottom:10px;
        }

        .sitting{
                background:#FFB3B5;
                color:#000;
        }

        .sitting:hover{
                background:#FF797C;
        }

        .onmyfeet{
                background:#FDD6B9;
                color:#000;
        }

        .onmyfeet:hover{
                background:#FCB37C;
        }

        .hustling{
                background-color:#DBEDC5;
                color:#000;
        }

        .hustling:hover{
                background:#A1D16D;
        }

        .activitity_level_selected{
                background-color: #79B9E3 !important;
                color: #fff;
                opacity: 1;
        }

        .activity_discarded{
                opacity: 0.4;
        }        

        .diet_goals_container{
                padding-bottom: 150px;
                display: block;
        }

        .body_fat_stored_images{
                text-align: center;
                padding: 20px;
        }

        .body_fat_stored_images img {
                height: 230px;
                padding: 10px;
        }

        .bfd-chosen{
                -webkit-filter: grayscale(0%) !important; /* Safari 6.0 - 9.0 */
                filter: grayscale(0%) !important;
        }

        .body_fat_stored_images img {
                -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
                filter: grayscale(100%);
                cursor: pointer;
        }

        .body_fat_stored_images img:hover{
                -webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
                filter: grayscale(0%);
        }

        .wizard-icon-circle{
                background-color: rgb(10, 20, 30)
        }
</style>



// WEBPACK FOOTER //
// src/views/Welcome/Welcome.vue